import { render } from "./TinymceModulesDemo.vue?vue&type=template&id=314b0084&scoped=true"
import script from "./TinymceModulesDemo.vue?vue&type=script&lang=ts"
export * from "./TinymceModulesDemo.vue?vue&type=script&lang=ts"

import "./TinymceModulesDemo.vue?vue&type=style&index=0&id=314b0084&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-314b0084"

export default script